interface LabFloHeroGraphicProps {
    className?: string;
}

export default function LabFloHeroGraphic({ className = "" }: LabFloHeroGraphicProps) {
    return (
        <svg 
            viewBox="0 0 500 500" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            {/* Background gradient circle */}
            <circle cx="250" cy="250" r="200" fill="url(#heroGradient)" opacity="0.1" />
            <circle cx="250" cy="250" r="150" fill="url(#heroGradient)" opacity="0.15" />
            <circle cx="250" cy="250" r="100" fill="url(#heroGradient)" opacity="0.2" />
            
            {/* Main Flask - Large Center */}
            <g transform="translate(175, 120)">
                {/* Flask body */}
                <path 
                    d="M60 0V50L20 130C10 150 25 170 50 170H100C125 170 140 150 130 130L90 50V0" 
                    stroke="url(#heroGradient)" 
                    strokeWidth="4" 
                    strokeLinecap="round" 
                    strokeLinejoin="round"
                    fill="none"
                />
                {/* Flask top */}
                <path d="M50 0H100" stroke="url(#heroGradient)" strokeWidth="4" strokeLinecap="round" />
                
                {/* Liquid inside */}
                <path 
                    d="M35 110C45 100 55 115 65 105C75 95 85 110 95 100C105 90 115 105 115 100" 
                    stroke="url(#heroGradient)" 
                    strokeWidth="3" 
                    strokeLinecap="round"
                    opacity="0.6"
                />
                
                {/* Bubbles */}
                <circle cx="55" cy="130" r="5" fill="url(#heroGradient)" opacity="0.4" />
                <circle cx="75" cy="140" r="4" fill="url(#heroGradient)" opacity="0.3" />
                <circle cx="90" cy="125" r="6" fill="url(#heroGradient)" opacity="0.5" />
            </g>
            
            {/* Test Tube 1 - Left */}
            <g transform="translate(80, 180) rotate(-15)">
                <rect x="0" y="0" width="30" height="100" rx="15" stroke="url(#heroGradient)" strokeWidth="3" fill="none" />
                <rect x="5" y="60" width="20" height="35" rx="10" fill="url(#heroGradient)" opacity="0.3" />
            </g>
            
            {/* Test Tube 2 - Right */}
            <g transform="translate(350, 180) rotate(15)">
                <rect x="0" y="0" width="30" height="100" rx="15" stroke="url(#heroGradient)" strokeWidth="3" fill="none" />
                <rect x="5" y="50" width="20" height="45" rx="10" fill="url(#heroGradient)" opacity="0.4" />
            </g>
            
            {/* Vial - Bottom Left */}
            <g transform="translate(100, 320)">
                <rect x="0" y="10" width="40" height="60" rx="5" stroke="url(#heroGradient)" strokeWidth="3" fill="none" />
                <rect x="5" y="0" width="30" height="15" rx="3" fill="url(#heroGradient)" opacity="0.5" />
                <rect x="8" y="40" width="24" height="25" rx="3" fill="url(#heroGradient)" opacity="0.25" />
            </g>
            
            {/* Vial - Bottom Right */}
            <g transform="translate(360, 320)">
                <rect x="0" y="10" width="40" height="60" rx="5" stroke="url(#heroGradient)" strokeWidth="3" fill="none" />
                <rect x="5" y="0" width="30" height="15" rx="3" fill="url(#heroGradient)" opacity="0.5" />
                <rect x="8" y="35" width="24" height="30" rx="3" fill="url(#heroGradient)" opacity="0.25" />
            </g>
            
            {/* Clipboard/Checklist - Top Right */}
            <g transform="translate(340, 80)">
                <rect x="0" y="10" width="60" height="80" rx="5" stroke="url(#heroGradient)" strokeWidth="3" fill="none" />
                <rect x="15" y="0" width="30" height="20" rx="3" fill="url(#heroGradient)" opacity="0.4" />
                {/* Check lines */}
                <line x1="12" y1="35" x2="48" y2="35" stroke="url(#heroGradient)" strokeWidth="2" opacity="0.5" />
                <line x1="12" y1="50" x2="48" y2="50" stroke="url(#heroGradient)" strokeWidth="2" opacity="0.5" />
                <line x1="12" y1="65" x2="48" y2="65" stroke="url(#heroGradient)" strokeWidth="2" opacity="0.5" />
                {/* Checkmarks */}
                <path d="M15 33L18 36L24 30" stroke="url(#heroGradient)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M15 48L18 51L24 45" stroke="url(#heroGradient)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            
            {/* Temperature/Thermometer - Top Left */}
            <g transform="translate(80, 80)">
                <rect x="10" y="0" width="20" height="70" rx="10" stroke="url(#heroGradient)" strokeWidth="3" fill="none" />
                <circle cx="20" cy="75" r="15" stroke="url(#heroGradient)" strokeWidth="3" fill="none" />
                <circle cx="20" cy="75" r="8" fill="url(#heroGradient)" opacity="0.5" />
                <rect x="15" y="30" width="10" height="40" rx="5" fill="url(#heroGradient)" opacity="0.4" />
            </g>
            
            {/* Floating particles/dots */}
            <circle cx="150" cy="150" r="4" fill="url(#heroGradient)" opacity="0.3" />
            <circle cx="350" cy="160" r="3" fill="url(#heroGradient)" opacity="0.4" />
            <circle cx="180" cy="380" r="5" fill="url(#heroGradient)" opacity="0.25" />
            <circle cx="320" cy="390" r="4" fill="url(#heroGradient)" opacity="0.35" />
            <circle cx="420" cy="250" r="3" fill="url(#heroGradient)" opacity="0.3" />
            <circle cx="80" cy="260" r="4" fill="url(#heroGradient)" opacity="0.35" />
            
            {/* Sparkles */}
            <g transform="translate(300, 130)">
                <line x1="0" y1="10" x2="0" y2="0" stroke="url(#heroGradient)" strokeWidth="2" strokeLinecap="round" opacity="0.6" />
                <line x1="-5" y1="5" x2="5" y2="5" stroke="url(#heroGradient)" strokeWidth="2" strokeLinecap="round" opacity="0.6" />
            </g>
            <g transform="translate(200, 100)">
                <line x1="0" y1="8" x2="0" y2="0" stroke="url(#heroGradient)" strokeWidth="2" strokeLinecap="round" opacity="0.5" />
                <line x1="-4" y1="4" x2="4" y2="4" stroke="url(#heroGradient)" strokeWidth="2" strokeLinecap="round" opacity="0.5" />
            </g>
            
            {/* Gradient definitions */}
            <defs>
                <linearGradient id="heroGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stopColor="#7C3AED" />
                    <stop offset="50%" stopColor="#8B5CF6" />
                    <stop offset="100%" stopColor="#5B21B6" />
                </linearGradient>
            </defs>
        </svg>
    );
}
